import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param organisationId String
 * @return {Promise<any>|Promise}
 */
export default (function (organisationId) {
    var url = applyPathVariables(EndPoints.GET_ALL_ASSET_ICONS, { organisationId: organisationId });
    var request = new Request({ method: Methods.GET, url: url, withCredentials: true });
    return request.execute();
});
